<template>
  <div class="view">
    <header>
      <h1>AR</h1>
    </header>
  </div>
</template>

<script>
import mdFile from '@/markdown/about.md'
// @ is an alias to /src
export default {
  name: 'AR',
  data () {
    return {
      text: ''
    }
  },
  computed: {
    stage () {
      return this.$store.state.stage
    },
    md () {
      return mdFile
    }
  }
}
</script>

<style lang="scss" scoped>
.view {
  pointer-events: auto;
}
</style>
